var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.392,6.512a1.356,1.356,0,1,1,0-2.711.9.9,0,0,0,0-1.807H7.867A3.166,3.166,0,0,0,4.705,5.156a2.949,2.949,0,0,0,.03.3.859.859,0,0,0-.03.151V26.063a3.948,3.948,0,0,0,3.943,3.943H26.392a.9.9,0,0,0,.9-.9V7.416A.9.9,0,0,0,26.392,6.512ZM7.867,3.8H23.534a3.165,3.165,0,0,0,0,2.711H7.867a1.356,1.356,0,0,1,0-2.711Zm8.585,4.518h3.614v7.348L18.76,14.8a.9.9,0,0,0-1,0l-1.306.871ZM25.488,28.2H8.648a2.138,2.138,0,0,1-2.136-2.136V8a3.128,3.128,0,0,0,1.355.317h6.778v9.036a.9.9,0,0,0,1.4.752l2.21-1.473,2.21,1.473a.9.9,0,0,0,1.4-.752V8.319h3.614Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.36f283c62f64e115b6f5838e7219a3a4.svg";
export { ForwardRef as ReactComponent };